var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.$style['icon-text-container'], _vm.$style[`icon-text-container-${_vm.size}`]]},[_c('div',{class:_vm.$style['icon-wrapper']},[(_vm.icon)?_c('img',{attrs:{"src":_vm.icon}}):_vm._e()]),(_vm.text)?_c('div',{class:_vm.$style['text-content']},[_vm._v(_vm._s(_vm.text))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }